import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useLoginByPhoneContext} from '../LoginByPhoneContext';
import styles from './LoginByPhoneMessage.module.scss';

const LoginByPhoneMessage = () => {
  const {gotCode} = useLoginByPhoneContext();

  return (
    <div className={styles.message}>
      {!gotCode
        ? (
          <FormattedMessage
            id={'login-by-phone-form-message-getCode'}
            defaultMessage={'Please enter your phone number and we will send you an Code code to login'}
          />
        )
        : (
          <FormattedMessage
            id={'login-by-phone-form-message-confirmCode'}
            defaultMessage={'Please enter the code to login'}
          />
        )
      }
    </div>
  )
};

export default LoginByPhoneMessage;
